export function renderSlugHelpersComponentTemplate({
  stringify,
  ctxSingular,
  ctxTableVar
}: {
  stringify: string
  ctxSingular: string
  ctxTableVar: string
}): string {
  return `const SLUG_CONSTRAINT_NAME = ${stringify}
const SLUG_RETRY_LIMIT = 5

type SlugLookupClient = typeof db | Parameters<Parameters<typeof db.transaction>[0]>[0]

interface Resolve${ctxSingular}SlugOptions {
  requestedSlug?: unknown
  sourceValue?: unknown
  fallbackPrefix: string
  currentId?: string
}

function toSlugBase(value: unknown): string {
  if (typeof value !== 'string') return ''
  return slugify(value)
}

export function get${ctxSingular}SlugRetryLimit(): number {
  return SLUG_RETRY_LIMIT
}

export function is${ctxSingular}SlugConflict(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false
  const record = error as Record<string, unknown>
  if (record.code !== '23505') return false
  const constraint = typeof record.constraint === 'string' ? record.constraint : ''
  const message = typeof record.message === 'string' ? record.message : ''
  return constraint === SLUG_CONSTRAINT_NAME || message.includes(SLUG_CONSTRAINT_NAME)
}

export async function resolveUnique${ctxSingular}Slug(
  client: SlugLookupClient,
  options: Resolve${ctxSingular}SlugOptions
): Promise<string> {
  const requestedBase = toSlugBase(options.requestedSlug)
  const sourceBase = requestedBase ? '' : toSlugBase(options.sourceValue)
  const usesFallback = !requestedBase && !sourceBase
  const baseSlug = requestedBase || sourceBase || \`\${options.fallbackPrefix}-1\`
  const rows = await client
    .select({ id: ${ctxTableVar}.id, slug: ${ctxTableVar}.slug })
    .from(${ctxTableVar})
  const usedSlugs = new Set(
    rows
      .filter((row) => row.id !== options.currentId)
      .map((row) => row.slug)
      .filter((slug): slug is string => typeof slug === 'string' && slug.length > 0)
  )

  if (!usedSlugs.has(baseSlug)) return baseSlug

  let suffix = 2
  let candidate = usesFallback
    ? \`\${options.fallbackPrefix}-\${suffix}\`
    : \`\${baseSlug}-\${suffix}\`
  while (usedSlugs.has(candidate)) {
    suffix += 1
    candidate = usesFallback
      ? \`\${options.fallbackPrefix}-\${suffix}\`
      : \`\${baseSlug}-\${suffix}\`
  }

  return candidate
}`
}
